export enum EFaqApiUrl {
  CATEGORIES = '/api/faq/categories',
  ARTICLES = '/api/faq/articles',
  AUTHORS = '/api/faq/authors',
}
